import * as React from 'react';

function SvgComponent(props) {
  var fill = props.fill,
      size = props.size;
  return React.createElement("svg", {
    style: {
      margin: 'auto',
      background: '0 0'
    },
    width: size,
    height: size,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    display: "block"
  }, React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(45 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(90 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(135 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(180 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(225 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(270 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(315 50 50)"
  }));
}

SvgComponent.defaultProps = {
  fill: '#333',
  size: 14
};
export default SvgComponent;